export const SPECIFIC_NON_SEG_USERS_WHO_CAN_ACCESS_SEG_EMAIL_HISTORY = [
  // DEV msp zaneta-non-seg@titanhq.com
  "031dca4b-c6a8-4dba-82fc-3dac20b61e1f",
  // DEV customer zaneta-non-seg-cust@titanhq.com
  "dbc6ccc8-fb6b-4237-8e42-2c8972085d74",
  // STAGE msp zaneta-non-seg@titanhq.com
  "05ede8b1-9df5-4aad-b898-933f2a8c0ae5",
  // STAGE customer zaneta-non-seg-cust@titanhq.com
  "64400214-7b54-4cbf-bd79-e3bc6a37e905",
  // PROD msp adNET INc
  "dbde1974-3f18-451d-86ee-c43012be961c",
  // PROD customers of adNET INc msp
  "0066ce4a-f346-4724-b632-cd3225adb66c",
  "02cbf27e-f966-4061-85b4-5a5af27192be",
  "06f61aa1-d2e6-4a89-b73b-99c4f89edc05",
  "077cd3db-d8f0-4bb3-b3e9-d09a4b49e22c",
  "087b3ede-cbc1-4388-9eec-0352948a5844",
  "0b37d0de-adf4-4207-9dcd-adfdb78215dd",
  "0d9c827a-d142-4b32-ad5b-99896d60fbef",
  "1457bb39-1904-49e6-9793-dfdef342f29d",
  "149ba01a-84e5-4e28-9cbb-9b568b1401f9",
  "171a993e-0618-4884-b666-920bdb33c042",
  "1ba8b109-d6d6-432a-9043-9f15566265e2",
  "1bb3fd7c-811d-4dc9-a7b5-9199d4c0b96e",
  "1bd89b13-ed05-45fc-a8a0-ae1ff85d5e61",
  "1ce29261-ed3b-4010-9135-379f5c9ef3cb",
  "1d95c260-01a4-48a5-a212-9b9419bc0541",
  "2118a2a2-5a50-4b77-92d1-a038b008e18a",
  "23b388ae-d740-4780-9579-a96794d00f4e",
  "2527acd9-f919-41d0-b69a-a9f70bfb7216",
  "265c18d7-473d-4161-aff9-8ea8b91fb6db",
  "2abaa1d2-8cfb-4de2-94ee-80d94305038d",
  "2ae932fe-3192-42fe-8ef9-ba161721794e",
  "2c2d5af5-dc22-47c0-b4f6-39f1688fe0fa",
  "2ccbcaac-3883-46c7-990c-6fbc001e40f6",
  "2e45081f-829c-4121-9510-557e41867f28",
  "326affb1-e182-48e8-8d57-395181b590e6",
  "32de6ad9-77c1-4e69-b6c0-cb162376e17a",
  "33f1f9db-2d92-4c80-9a72-a723f562e21a",
  "34695f79-c182-496e-bd89-5913fa4bbaf6",
  "38aa5a35-3a69-4a52-9f2d-5153674a2899",
  "38fe63a8-fa03-46cf-857e-25e59dae8144",
  "399afaf1-24ea-4ac8-9fda-84b16c48253f",
  "3c4e41ad-bf56-4552-8e92-cb4e07260d34",
  "40ed6e86-a1c6-46ce-a74b-839985537d37",
  "42fc3bf9-d5fc-4e48-be30-723382315a56",
  "470df3bc-77bf-4015-bfca-45baeccfda23",
  "47131b45-79ea-4af5-9747-507f8b920489",
  "48d7ee96-df3e-49f2-8ade-c6d94f1f3772",
  "48f116b3-187b-49e6-ae42-551f0df1c981",
  "49981c84-343d-4b13-8d9b-3d13c640c05f",
  "51003d05-6b2a-4785-a18f-321ad768951c",
  "5b064da6-853b-42e7-9d88-7107b4063435",
  "5b12db1b-4fe3-4e24-a8e4-d3a68267ff60",
  "5f425ea9-fcd8-4322-951e-3cac9aa3e158",
  "608ee512-0af5-4c03-af85-242626e5db12",
  "66d2b8c4-f0f4-4bae-bf53-780f555567ef",
  "68e1d2fa-af8d-4f89-aa2d-b4356dbb7424",
  "6bbedb6c-9a75-4962-9be1-e2f5e85b508d",
  "6c2d2134-6f7e-4a6b-8743-216486788c56",
  "7525c451-2e01-442b-bd15-ac4d6d691d52",
  "777b9e55-10de-4f49-b001-8cdedece965d",
  "77e6d610-fb26-4f4f-963d-1fea326912f2",
  "7b21d276-d875-4986-a601-7300ba58913a",
  "7dab9d3b-e433-4514-96c9-86b251f12f50",
  "7e4c04ef-b5c9-49a6-aaa8-3d05ad640a15",
  "7e5e5eda-bd22-4e51-aa90-7ddedc2baa73",
  "80a045a9-1c1d-4b49-8ffd-2fcb8412c8e1",
  "81b1ffde-e41b-4a98-9145-a99f358f3e8b",
  "859cc709-b46f-4c13-9661-ff4dde326c02",
  "87ac1514-5213-4cb5-9ea8-bb2b534850e2",
  "88c625a8-447b-446d-9a66-933a4dcef9dc",
  "89cab22a-219e-4326-bfe9-62e77c455dea",
  "8a48d32c-3cce-4a1b-861a-2b6afc0d9f37",
  "8ad43632-4830-414f-b77a-b10a124c1071",
  "8bcdead5-c1ad-4277-b2d4-74d33fdcbd65",
  "8f43e414-4aa7-4647-9891-9bc107d34ebf",
  "90662b4a-ba07-46dc-af04-d3f5e272eb9c",
  "90ab7976-ffad-4292-8257-02f189b3645a",
  "934acb03-a38c-4563-a6cc-b504e91f9012",
  "94b805b1-48c2-4769-b8a1-02cdfc46089c",
  "950bb49e-89af-47b3-9e3b-e65821a100e7",
  "9b3dc0be-abf8-4ed8-bd31-59edca6d1cfc",
  "9e3e964f-1099-41ab-9261-610700c87b95",
  "a3fc3055-926f-4d3b-b4dd-b804f9a20891",
  "a74fddeb-7df1-4d52-b44b-c10bcff0719d",
  "a9587352-a52e-45aa-8773-0ed0ff0fb643",
  "aae805e1-b52b-43ad-b608-5bba03e54b80",
  "abc5235b-63b3-4454-ad0b-49c61a07259c",
  "ad949f0f-6918-4634-90e3-ec177d72273d",
  "b2a3e401-4fdf-4adf-b802-3ddccfb17253",
  "b3ef6f92-5aa1-495c-95c3-c499c047f3b3",
  "b7744f23-aaec-422b-8c36-813b27927e19",
  "b830b603-04b2-46c1-b81f-039cf621c2eb",
  "b8634da3-01d7-4cdc-bbfe-00d6f2afd4af",
  "b89d8a26-349a-49a9-baf5-34a2880e00bb",
  "b8c088e1-7bd7-4bf1-a8e6-fd4c2d1fda7b",
  "ba9880f8-0b03-46ee-aac7-3559539cb4d8",
  "bc981bb8-ea99-4dd3-a489-5695f38306b6",
  "bcb5d130-ebb9-4e69-a2c4-9b7e1cba450c",
  "c1ad3d06-8bd1-41a5-8004-939955708bfd",
  "c33aede8-3928-4d98-818b-6a85f078852a",
  "c38b3ec5-db36-47cd-83ab-0daf6686eb89",
  "c70e14c6-5cea-4f52-baf3-5b8116631c91",
  "c8925975-634d-43ae-b46b-2bb1b4fdc231",
  "c94b6c95-e04d-48f7-9f5f-334168bc8535",
  "cb3cdda1-288b-4275-be28-83051c577216",
  "cfb5fbd6-8374-4247-968e-16f8a699141d",
  "d35c0d2f-9714-4486-af34-6ea35403d3fa",
  "d7aabb8e-8e73-4630-9e5c-9fea9f7dfc22",
  "da2bebee-6fdc-4d82-b654-f310632a281e",
  "daffb896-097f-4b5b-9776-b18417d32fd7",
  "db609910-7c79-4c09-aa2e-2bd138da55b1",
  "dca0806f-cf94-48e5-a94d-c15b17db764a",
  "e1aee681-ce91-4177-b9b8-99e499f89e21",
  "e44076b6-e5ef-4c69-969b-7686eebd1aba",
  "e63d1a52-6e2b-4e47-874c-0a5d0d9a1d9f",
  "e65bdbea-37d9-4ceb-81d6-03ae5e6c9e16",
  "e68abab8-ae9f-438d-afe0-2917e4c5e5b5",
  "e73ca97b-3360-4ea2-807f-d6da4a28ef8b",
  "e7db9bae-a88c-497b-afc8-322ee573eb0b",
  "e8733817-2d39-4cde-93ad-0b36ca602a4b",
  "e99fc4c4-a07f-4ea2-bd0d-3dbb27352cba",
  "eb014739-326e-4a6a-b98d-82b4416ce4a6",
  "ed82cc3a-13ca-4ac7-99f8-cfddade43398",
  "f04f8366-5d2d-462c-bbde-0b3bf799de30",
  "f15c05a5-c842-47e9-825c-f7aa39469477",
  "f1bc0bd8-1670-4c67-819a-915df1aaef1c",
  "f2ee7577-d681-4b59-ad1c-b1cf85fb11ea",
  "f3fb8f8b-eb57-4fb9-9a8d-81d07e2b2294",
  "f5b2ab97-4d36-4353-a14d-fbaf3758ae76",
  "f69548dc-e276-431e-b178-0d9ef3d431cf",
  "fa254b3d-9b14-486e-ab2a-0dd0713bbbfb",
  "fa3bacc6-e7fe-47f6-9852-5aa04e187278",
  "fa466fd5-9296-42ac-a22f-f51dd21a4c34",
  "fa8feee0-5925-4eca-b41b-26a043484b48",
  "fe0b14a4-e793-436b-8ec1-e1354a996eeb",
  "ffa47e23-889c-4d29-acda-9c5846a34578",
];
